/** FCM uses Firebase Installations credentials, independently of user sign-in. */
export async function recoverToken(
  requestToken: () => Promise<string>,
  refreshInstallation: () => Promise<unknown>,
): Promise<string> {
  try {
    return await requestToken();
  } catch (error) {
    const failure = error as { code?: string; message?: string } | null;
    const registrationFailure =
      failure?.code === 'messaging/token-subscribe-failed' ||
      failure?.code === 'messaging/token-update-failed';
    if (
      !registrationFailure ||
      !/missing required authentication credential|UNAUTHENTICATED|invalid authentication credentials/i.test(
        failure?.message ?? '',
      )
    ) {
      throw error;
    }

    // Retry once. Persistent project/VAPID configuration errors must still surface.
    await refreshInstallation();
    return requestToken();
  }
}
